<template>
  <div class="content_wrap">
    <div class="content" v-if="data.content || data.irContent" v-html="convertToHtml(data)"></div>
    <div class="download_wrap" v-if="data.attachment">
      <p class="download">
        请点击下载附件: <a download="附件" :href="data.attachment">附件下载</a>
      </p>
    </div>
    <div class="easy_info">
      <p class="info">特别提醒：</p>
      <p class="detail">文章内容仅代表作者个人观点，仅供阅读交流，所有内容不构成投资建议，不作为买卖依据，据此操作风险自负。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'components-article-detail',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    convertToHtml (data) {
      if (!data.irContent) {
        return data.content[0].content
      }

      let arr = data.irContent.split('\r\n')
      arr = arr.map(_ => '<p>' + _ + '</p>')
      return arr.join('')
    }
  }
}
</script>

<style lang="less" scoped>
.content_wrap { padding-top: 33px;
  .content { font-size: 14px; width: 776px; word-break: break-all; line-height: 1.8; }
  .download_wrap {
    margin-top: 20px;
  	.download { font-size: 14px;
  		a { margin-left: 4px; color: #CC0000; }
  	}
  }
}
.easy_info { padding-top: 7px;
	.info { line-height: 44px; font-size: 16px; color: #666; font-weight: 600; }
	.detail { line-height: 25px; font-size: 14px; text-indent: 28px; color: #666; word-break: break-word; }
}
</style>
